import React from "react";
import ReactMarkdown from "react-markdown";
import { Typography, Table } from "antd";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { markdownComponents } from "../../../../../components/markdownComponents";

const { Text } = Typography;

interface CompanyProfileTabProps {
  selectedStock: any;
}

export const CompanyProfileTab: React.FC<CompanyProfileTabProps> = ({
  selectedStock,
}) => {
  if (!selectedStock?.ai_reviewed_summary) {
    return (
      <div className="vi-glass-card flex items-center justify-center p-12 max-w-5xl mx-auto mt-4">
        <Text type="secondary">No AI summary available for this stock.</Text>
      </div>
    );
  }

  return (
    <div className="vi-glass-card p-6 md:p-8 w-full mt-4">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        components={markdownComponents}
      >
        {selectedStock.ai_reviewed_summary}
      </ReactMarkdown>
    </div>
  );
};
